module.exports = __webpack_public_path__ + "static/media/contacts-icon.c29e229a.png";